module.exports = __webpack_public_path__ + "img/suny.ef6bd023.png";